import { BsCheckLg } from "react-icons/bs";
import { RxCross2 } from 'react-icons/rx';


export const PricingData = [
  {
    id: 1,
    name: "Basic Plan",
    para: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration",
    price: "33.00",
    feture: [
      {
        data: <><BsCheckLg/>10 GB Storage</>,
      },
      {
        data: <><BsCheckLg/>10 Photos and Videos</>,
      },
      {
        data: <><BsCheckLg/>10 GB Storage</>,
      },
      {
        data: <><RxCross2 className="text-troo-primary"/>Exclusive Support</>,
      },
      {
        data: <><RxCross2 className="text-troo-primary"/>No Custom Field</>,
      },
    ],
  },
  {
    id: 2,
    name: "Plus Plan",
    para: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration",
    price: "66.00",
    feture: [
      {
        data: <><BsCheckLg/>10 GB Storage</>,
      },
      {
        data: <><BsCheckLg/>10 Photos and Videos</>,
      },
      {
        data: <><BsCheckLg/>10 GB Storage</>,
      },
      {
        data: <><RxCross2 className="text-troo-primary"/>Exclusive Support</>,
      },
      {
        data: <><RxCross2 className="text-troo-primary"/>No Custom Field</>,
      },
    ],
  },
  {
    id: 3,
    name: "Pro Plan",
    para: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration",
    price: "89.00",
    feture: [
      {
        data: <><BsCheckLg/>10 GB Storage</>,
      },
      {
        data: <><BsCheckLg/>10 Photos and Videos</>,
      },
      {
        data: <><BsCheckLg/>10 GB Storage</>,
      },
      {
        data: <><RxCross2 className="text-troo-primary"/>Exclusive Support</>,
      },
      {
        data: <><RxCross2 className="text-troo-primary"/>No Custom Field</>,
      },
    ],
  },
  {
    id: 4,
    name: "Prime Plan",
    para: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration",
    price: "99.00",
    feture: [
      {
        data: <><BsCheckLg/>10 GB Storage</>,
      },
      {
        data: <><BsCheckLg/>10 Photos and Videos</>,
      },
      {
        data: <><BsCheckLg/>10 GB Storage</>,
      },
      {
        data: <><RxCross2 className="text-troo-primary"/>Exclusive Support</>,
      },
      {
        data: <><RxCross2 className="text-troo-primary"/>No Custom Field</>,
      },
    ],
  },
  {
    id: 5,
    name: "Enterprise Plan",
    para: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration",
    price: "125.00",
    feture: [
      {
        data: <><BsCheckLg/>10 GB Storage</>,
      },
      {
        data: <><BsCheckLg/>10 Photos and Videos</>,
      },
      {
        data: <><BsCheckLg/>10 GB Storage</>,
      },
      {
        data: <><RxCross2 className="text-troo-primary"/>Exclusive Support</>,
      },
      {
        data: <><RxCross2 className="text-troo-primary"/>No Custom Field</>,
      },
    ],
  },
  {
    id: 6,
    name: "Platinium Plan",
    para: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration",
    price: "200.00",
    feture: [
      {
        data: <><BsCheckLg/>10 GB Storage</>,
      },
      {
        data: <><BsCheckLg/>10 Photos and Videos</>,
      },
      {
        data: <><BsCheckLg/>10 GB Storage</>,
      },
      {
        data: <><RxCross2 className="text-troo-primary"/>Exclusive Support</>,
      },
      {
        data: <><RxCross2 className="text-troo-primary"/>No Custom Field</>,
      },
    ],
  },
];
